import { FC } from "react"
import { Circle } from "lucide-react"
import { Channel } from "../../../../../types"

interface Props {
  info: Channel
}

const StatusCell: FC<Props> = ({ info }) => {
  const statusConfig = {
    active: {
      bg: "bg-emerald-50",
      text: "text-emerald-700",
      dot: "text-emerald-500",
      label: "Active"
    },
    paused: {
      bg: "bg-amber-50",
      text: "text-amber-700",
      dot: "text-amber-500",
      label: "Paused"
    },
    disabled: {
      bg: "bg-gray-100",
      text: "text-gray-600",
      dot: "text-gray-400",
      label: "Disabled"
    }
  }

  const config = statusConfig[info.status] || statusConfig.disabled

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold ${config.bg} ${config.text}`}
    >
      <Circle size={6} className={`fill-current ${config.dot}`} />
      {config.label}
    </span>
  )
}

export default StatusCell
